export const lightMedium = () => ({ item: { width: 110, paddingLeft: 0, paddingRight: 0 } });
export const alignRight = () => ({
  buttonsContainer: {
    justifyContent: 'end',
  },
});
